import * as React from "react";
import { IFormType } from "../../../model/formconfiguration/FormType";
import Dialog from "../../components/app/Dialog";

const PublishFormVersionDialog = ({
  publishFormVersionDialogVisible,
  hidePublishFormVersionDialog,
  translate,
  publishFormVersion,
  rowData
}: {
  publishFormVersionDialogVisible: boolean;
  hidePublishFormVersionDialog(): void;
  translate: any;
  publishFormVersion(roleTypeCode: string): void;
  rowData: IFormType;
}) => {
  return (
    <Dialog
      title={translate("publish_form_version_dialog.title")}
      modalVisible={publishFormVersionDialogVisible}
      onCancel={(e) => hidePublishFormVersionDialog()}
      onOk={(e) => {
        publishFormVersion(rowData.code);
        hidePublishFormVersionDialog();
      }}
      okText={translate("publish_form_version_dialog.publish")}
      cancelText={translate("publish_form_version_dialog.cancel")}
    >
      {translate("publish_form_version_dialog.text")}
    </Dialog>
  );
};

export default PublishFormVersionDialog;
